export const defaultLocale = 'ru'

export const localeOptions = [
  { id: 'en', name: 'English' },
  { id: 'ru', name: 'Русский' },
  { id: 'uz', name: 'Uzbek' }
]

export const apiUrl = 'https://dorsaapi.sosgroup.uz'
